module.exports = __webpack_public_path__ + "media/images/bag-1e86f8e2beee990400460b8988b68eea.svg";